// ログイン後に戻す遷移先を保持するクエリパラメータ名（#3184）。
// 未ログインで直接URLを開いた場合に、ログイン後そのページへ復帰させるために使う。
export const LOGIN_REDIRECT_QUERY_KEY = 'redirect';

// ログイン後の既定の遷移先
const DEFAULT_REDIRECT_PATH = '/home';

/**
 * 現在のURL（パス+クエリ+ハッシュ）を redirect パラメータに載せたログイン画面のURLを組み立てる。
 * 未ログイン状態で保護されたページを開いたときに使う。
 */
export const buildLoginPathWithRedirect = (
  pathname: string,
  search: string,
  hash: string,
): string => {
  const target = `${pathname}${search}${hash}`;
  // ログイン画面自体へのループを避ける
  if (pathname === '/') return '/';
  return `/?${LOGIN_REDIRECT_QUERY_KEY}=${encodeURIComponent(target)}`;
};

/**
 * ログイン後の遷移先を返す。
 * redirect パラメータが無い、または外部URL等の安全でない値なら既定の遷移先を返す。
 *
 * オープンリダイレクト対策として、自サイト内の絶対パス（"/" 始まり）のみ許可し、
 * "//" 始まり（プロトコル相対URL＝外部サイト）は拒否する。
 */
export const resolveLoginRedirectPath = (search: string): string => {
  try {
    const raw = new URLSearchParams(search).get(LOGIN_REDIRECT_QUERY_KEY);
    if (!raw) return DEFAULT_REDIRECT_PATH;
    // 自サイト内のパスのみ許可（外部サイトへのリダイレクトを防ぐ）
    if (!raw.startsWith('/') || raw.startsWith('//')) return DEFAULT_REDIRECT_PATH;
    return raw;
  } catch {
    // URL が解析できない環境では既定の遷移先へ
    return DEFAULT_REDIRECT_PATH;
  }
};
